import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import WebPanelLocationQuery, {
	type WebPanelLocationQuery$data,
	type WebPanelLocationQuery$variables,
} from './__generated__/WebPanelLocationQuery.graphql.ts';

export function preloadWebPanelLocation(variables: WebPanelLocationQuery$variables) {
	return query<WebPanelLocationQuery$data, WebPanelLocationQuery$variables>({
		query: WebPanelLocationQuery,
		variables,
	});
}
